import { render, staticRenderFns } from "./LoginCB.vue?vue&type=template&id=03a90609&scoped=true"
import script from "./LoginCB.vue?vue&type=script&lang=js"
export * from "./LoginCB.vue?vue&type=script&lang=js"
import style0 from "./LoginCB.vue?vue&type=style&index=0&id=03a90609&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a90609",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a90609')) {
      api.createRecord('03a90609', component.options)
    } else {
      api.reload('03a90609', component.options)
    }
    module.hot.accept("./LoginCB.vue?vue&type=template&id=03a90609&scoped=true", function () {
      api.rerender('03a90609', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/oauthFPX/LoginCB.vue"
export default component.exports